import { defineStore } from 'pinia'
import { includes } from 'lodash'

export const useUserStore = defineStore('userStore', {
  state: () => ({
    user: {
      email: '',
      displayName: '',
    },
    autenticarUser: {
      first_name: null,
      autenticated: null,
      last_name: null,
      activated: false,
      dni: null,
      levelCidi: null,
      alreadyRegister: null,
      hasLevelRequired: null,
      levelUpdated: null,
      tipoPersona: null,
      created: null,
      uid: null,
    },
    isHomeTop: true,
    currentUrl: '',
    loggedIn: false,
    grecaptcha: null,
  }),

  actions: {
    onAuthStateChangedAction({ authUser }) {
      if (!authUser) {
        this.user = {}
        this.loggedIn = false
      } else {
        const { uid, email, emailVerified, phoneNumber, role, auxRole } =
          authUser

        const typeProfile =
          role &&
          includes(
            ['superadmin', 'admin', 'operator', 'editor', 'communicator'],
            role
          )
            ? 'Funcionario'
            : auxRole && includes(['officer'], auxRole)
            ? 'Funcionario'
            : 'Ciudadano'

        this.user = {
          uid,
          email,
          emailVerified,
          phoneNumber,
          role,
          typeProfile,
        }
        this.loggedIn = true
      }
    },
    setUserAutenticar({ autenticar }) {
      // eslint-disable-next-line no-console
      console.log('Actualizando el store de autenticarUser')
      const data = { ...this.autenticarUser, ...autenticar }
      this.autenticarUser = Object.assign({}, this.autenticarUser, data)
    },

    setloggedIn(loggedIn) {
      this.loggedIn = loggedIn
    },

    setIsHomeTop(isTop) {
      this.isHomeTop = isTop
    },

    setHost() {
      const currentUrl = `${window.location.protocol}//${window.location.host}`
      this.currentUrl = currentUrl
    },

    setUser(user) {
      this.user = user
    },
  },
})
